<style scoped lang="less">
	.tips{
	font-size: 12px;
	color: #999;
	padding: 10px 20px 0;
	
	a{
		color: #3e79ed;
	}
}
</style>
<template>
	<el-dialog :visible="visible" width='600px' title="链接至其它小程序" :append-to-body="true" @close="cancel">

		<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="ruleForm">
			<el-form-item label="小程序AppID" prop="appId">
				<el-input v-model="ruleForm.appId" style="width: 350px;" placeholder="请输入要跳转的小程序AppID"></el-input>
			</el-form-item>
			<el-form-item label="页面路径" prop="path">
				<el-input v-model="ruleForm.path" style="width: 350px;" placeholder="请输入小程序页面路径"></el-input>
			</el-form-item>
		</el-form>

		<div class="tips">
			使用此功能时请严格遵守<a href="https://developers.weixin.qq.com/miniprogram/product/#_5-10-%E4%BA%92%E6%8E%A8%E8%A1%8C%E4%B8%BA" target="_blank">《微信小程序平台运营规范》</a>，若发现小程序违反运营规范将被下架处理
		</div>

		<div slot="footer">
			<el-button type="primary" @click="btnSure">确定</el-button>
		</div>

	</el-dialog>
</template>
<script>
	import config from '@/config/index'

	export default {
		components: {},
		props: {
			visible: {
				type: Boolean,
				default: false
			},
			data: {
				type: Object,
				default: ()=>{
					return {}
				}
			}
		},
		watch: {
			data(obj){
				if (obj.selectedData && obj.selectedData.data){
					this.ruleForm = {
						appId: obj.selectedData.data.appId,
						path: obj.selectedData.data.path
					}
				}else{
					if (this.ruleForm.appId){
						this.reset()
					}
				}
			}
		},
		data() {
			return {
				show: false,
				ruleForm: {
					appId: '',
					path: ''
				},
				rules: {
					appId: [{
						required: true,
						message: '请输入要跳转的小程序AppID',
						trigger: 'change'
					}],
					path: [{
						required: true,
						message: '请输入小程序页面路径',
						trigger: 'change'
					}],
				}
			};
		},
		methods: {
			cancel() {
				this.$emit('cancel');
			},
			btnSure() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$emit('change', {
							type: 'miniProgram',
							text: '其它小程序|'+this.ruleForm.path,
							data: JSON.parse(JSON.stringify(this.ruleForm))
						})
						this.$refs['ruleForm'].resetFields();
						this.cancel();
					} else {
						return false;
					}
				});
			},
			reset() {
				this.$refs['ruleForm'].resetFields();
			}
		},
		
		mounted() {

		},
		created() {

		},
		dispatch() {

		}
	};
</script>
